"use strict";
/**
 * AUTOGENERATED - DO NOT EDIT DIRECTLY
 *
 * Please see "scripts/regionalization/README.md" for how to modify
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED = exports.ISO_ISO2_MAPPING = exports.countryCodeToIsoCountryCodeMap = exports.ISO2_ISO_MAPPING = exports.IsoCountryCodeToCurrencyNameMap = exports.IsoCountryCode2Char = exports.IsoCountryCode = exports.CountryCodeToCurrencyNameMap = void 0;
/**
 * Mapping from ISO 3166-1 alpha-2 country code to currency code
 */
var CountryCodeToCurrencyNameMap;
(function (CountryCodeToCurrencyNameMap) {
    /**
     * United Arab Emirates (Dirham)
     */
    CountryCodeToCurrencyNameMap["AE"] = "AED";
    /**
     * Antarctica (Dollar)
     */
    CountryCodeToCurrencyNameMap["AQ"] = "USD";
    /**
     * Austria (Euro)
     */
    CountryCodeToCurrencyNameMap["AT"] = "EUR";
    /**
     * Argentina (Pound)
     */
    CountryCodeToCurrencyNameMap["AR"] = "ARS";
    /**
     * Australia (Dollar)
     */
    CountryCodeToCurrencyNameMap["AU"] = "AUD";
    /**
     * Bahrain (Dinar)
     */
    CountryCodeToCurrencyNameMap["BH"] = "BHD";
    /**
     * Brazil (Real)
     */
    CountryCodeToCurrencyNameMap["BR"] = "BRL";
    /**
     * Canada (Dollar)
     */
    CountryCodeToCurrencyNameMap["CA"] = "CAD";
    /**
     * Switzerland (Franc)
     */
    CountryCodeToCurrencyNameMap["CH"] = "CHF";
    /**
     * Chile (Pound)
     */
    CountryCodeToCurrencyNameMap["CL"] = "CLP";
    /**
     * Czech Republic (Koruna)
     */
    CountryCodeToCurrencyNameMap["CZ"] = "CZK";
    /**
     * Germany (Euro)
     */
    CountryCodeToCurrencyNameMap["DE"] = "EUR";
    /**
     * Dominican Republic (Euro)
     */
    CountryCodeToCurrencyNameMap["DO"] = "DOP";
    /**
     * Egypt (Pound)
     */
    CountryCodeToCurrencyNameMap["EG"] = "EGP";
    /**
     * Kuwait (Dinar)
     */
    CountryCodeToCurrencyNameMap["KW"] = "KWD";
    /**
     * Cayman Islands (Dollar)
     */
    CountryCodeToCurrencyNameMap["KY"] = "KYD";
    /**
     * Spain (Euro)
     */
    CountryCodeToCurrencyNameMap["ES"] = "EUR";
    /**
     * France (Euro)
     */
    CountryCodeToCurrencyNameMap["FR"] = "EUR";
    /**
     * United Kingdom (Pound)
     */
    CountryCodeToCurrencyNameMap["GB"] = "GBP";
    /**
     * Ireland (EUR)
     */
    CountryCodeToCurrencyNameMap["IE"] = "EUR";
    /**
     * Italy (EUR)
     */
    CountryCodeToCurrencyNameMap["IT"] = "EUR";
    /**
     * South Korea (Won)
     */
    CountryCodeToCurrencyNameMap["KR"] = "KRW";
    /**
     * Morocco (Dirham)
     */
    CountryCodeToCurrencyNameMap["MA"] = "MAD";
    /**
     * Mauritius (Rupee)
     */
    CountryCodeToCurrencyNameMap["MU"] = "MUR";
    /**
     * Malaysia (Ringgit)
     */
    CountryCodeToCurrencyNameMap["MY"] = "MYR";
    /**
     * Mexico (Pound)
     */
    CountryCodeToCurrencyNameMap["MX"] = "MXN";
    /**
     * Netherlands (Euro)
     */
    CountryCodeToCurrencyNameMap["NL"] = "EUR";
    /**
     * New Zealand (Dollar)
     */
    CountryCodeToCurrencyNameMap["NZ"] = "NZD";
    /**
     * Oman (Rial)
     */
    CountryCodeToCurrencyNameMap["OM"] = "OMR";
    /**
     * Philippines (Peso)
     */
    CountryCodeToCurrencyNameMap["PH"] = "PHP";
    /**
     * Poland (Zloty)
     */
    CountryCodeToCurrencyNameMap["PL"] = "PLN";
    /**
     * Puerto Rico (Dollar)
     */
    CountryCodeToCurrencyNameMap["PR"] = "USD";
    /**
     * Portugal (Euro)
     */
    CountryCodeToCurrencyNameMap["PT"] = "EUR";
    /**
     * Qatar (Riyal)
     */
    CountryCodeToCurrencyNameMap["QA"] = "QAR";
    /**
     * Romania (Leu)
     */
    CountryCodeToCurrencyNameMap["RO"] = "RON";
    /**
     * Saudi Arabia (Riyal)
     */
    CountryCodeToCurrencyNameMap["SA"] = "SAR";
    /**
     * Singapore (Dollar)
     */
    CountryCodeToCurrencyNameMap["SG"] = "SGD";
    /**
     * Taiwan (Dollar)
     */
    CountryCodeToCurrencyNameMap["TW"] = "TWD";
    /**
     * United States (Dollar)
     */
    CountryCodeToCurrencyNameMap["US"] = "USD";
    /**
     * South Africa (Rand)
     */
    CountryCodeToCurrencyNameMap["ZA"] = "ZAR";
})(CountryCodeToCurrencyNameMap = exports.CountryCodeToCurrencyNameMap || (exports.CountryCodeToCurrencyNameMap = {}));
/**
 * Any valid ISO 3166-1 alpha-3 (3 character) country code
 */
var IsoCountryCode;
(function (IsoCountryCode) {
    /**
     * United Arab Emirates (AE)
     */
    IsoCountryCode["ARE"] = "ARE";
    /**
     * Argentina (AR)
     */
    IsoCountryCode["ARG"] = "ARG";
    /**
     * Antarctica (AQ)
     */
    IsoCountryCode["ATA"] = "ATA";
    /**
     * Austria (AT)
     */
    IsoCountryCode["AUT"] = "AUT";
    /**
     * Australia (AU)
     */
    IsoCountryCode["AUS"] = "AUS";
    /**
     * Bahrain (BH)
     */
    IsoCountryCode["BHR"] = "BHR";
    /**
     * Brazil (BR)
     */
    IsoCountryCode["BRA"] = "BRA";
    /**
     * Canada (CA)
     */
    IsoCountryCode["CAN"] = "CAN";
    /**
     * Switzerland (CH)
     */
    IsoCountryCode["CHE"] = "CHE";
    /**
     * Chile (CL)
     */
    IsoCountryCode["CHL"] = "CHL";
    /**
     * Cayman Islands (KY)
     */
    IsoCountryCode["CYM"] = "CYM";
    /**
     * Czech Republic (CZ)
     */
    IsoCountryCode["CZE"] = "CZE";
    /**
     * Germany (DE)
     */
    IsoCountryCode["DEU"] = "DEU";
    /**
     * Dominican Republic (DO)
     */
    IsoCountryCode["DOM"] = "DOM";
    /**
     * Egypt (EG)
     */
    IsoCountryCode["EGY"] = "EGY";
    /**
     * Kuwait (KW)
     */
    IsoCountryCode["KWT"] = "KWT";
    /**
     * Spain (ES)
     */
    IsoCountryCode["ESP"] = "ESP";
    /**
     * France (FR)
     */
    IsoCountryCode["FRA"] = "FRA";
    /**
     * United Kingdom (GB)
     */
    IsoCountryCode["GBR"] = "GBR";
    /**
     * Ireland (IE)
     */
    IsoCountryCode["IRL"] = "IRL";
    /**
     * Italy (IT)
     */
    IsoCountryCode["ITA"] = "ITA";
    /**
     * South Korea (KR)
     */
    IsoCountryCode["KOR"] = "KOR";
    /**
     * Morocco (MA)
     */
    IsoCountryCode["MAR"] = "MAR";
    /**
     * Mexico (MX)
     */
    IsoCountryCode["MEX"] = "MEX";
    /**
     * Mauritius (MU)
     */
    IsoCountryCode["MUS"] = "MUS";
    /**
     * Malaysia (MY)
     */
    IsoCountryCode["MYS"] = "MYS";
    /**
     * Netherlands (NL)
     */
    IsoCountryCode["NLD"] = "NLD";
    /**
     * New Zealand (NZ)
     */
    IsoCountryCode["NZL"] = "NZL";
    /**
     * Oman (OM)
     */
    IsoCountryCode["OMN"] = "OMN";
    /**
     * Philippines (PH)
     */
    IsoCountryCode["PHL"] = "PHL";
    /**
     * Poland (PL)
     */
    IsoCountryCode["POL"] = "POL";
    /**
     * Portugal (PT)
     */
    IsoCountryCode["PRT"] = "PRT";
    /**
     * Puerto Rico (PR)
     */
    IsoCountryCode["PRI"] = "PRI";
    /**
     * Qatar (QA)
     */
    IsoCountryCode["QAT"] = "QAT";
    /**
     * Romania (RO)
     */
    IsoCountryCode["ROU"] = "ROU";
    /**
     * Saudi Arabia (SA)
     */
    IsoCountryCode["SAU"] = "SAU";
    /**
     * Singapore (SG)
     */
    IsoCountryCode["SGP"] = "SGP";
    /**
     * Taiwan (TW)
     */
    IsoCountryCode["TWN"] = "TWN";
    /**
     * United States (US)
     */
    IsoCountryCode["USA"] = "USA";
    /**
     * South Africa (ZA)
     */
    IsoCountryCode["ZAF"] = "ZAF";
})(IsoCountryCode = exports.IsoCountryCode || (exports.IsoCountryCode = {}));
/**
 * Any valid ISO 3166-1 alpha-2 (2 character) country code
 */
var IsoCountryCode2Char;
(function (IsoCountryCode2Char) {
    /**
     * United Arab Emirates (ARE)
     */
    IsoCountryCode2Char["AE"] = "AE";
    /**
     * Argentina (ARG)
     */
    IsoCountryCode2Char["AR"] = "AR";
    /**
     * Antarctica (ATA)
     */
    IsoCountryCode2Char["AQ"] = "AQ";
    /**
     * Austria (AUT)
     */
    IsoCountryCode2Char["AT"] = "AT";
    /**
     * Australia (AUS)
     */
    IsoCountryCode2Char["AU"] = "AU";
    /**
     * Bahrain (BHR)
     */
    IsoCountryCode2Char["BH"] = "BH";
    /**
     * Brazil (BRA)
     */
    IsoCountryCode2Char["BR"] = "BR";
    /**
     * Canada (CAN)
     */
    IsoCountryCode2Char["CA"] = "CA";
    /**
     * Switzerland (CHE)
     */
    IsoCountryCode2Char["CH"] = "CH";
    /**
     * Chile (CHL)
     */
    IsoCountryCode2Char["CL"] = "CL";
    /**
     * Czech Republic (CZE)
     */
    IsoCountryCode2Char["CZ"] = "CZ";
    /**
     * Germany (DEU)
     */
    IsoCountryCode2Char["DE"] = "DE";
    /**
     * Dominican Republic (DOM)
     */
    IsoCountryCode2Char["DO"] = "DO";
    /**
     * Egypt (EGY)
     */
    IsoCountryCode2Char["EG"] = "EG";
    /**
     * Kuwait (KWT)
     */
    IsoCountryCode2Char["KW"] = "KW";
    /**
     * Cayman Islands (CYM)
     */
    IsoCountryCode2Char["KY"] = "KY";
    /**
     * Spain (ESP)
     */
    IsoCountryCode2Char["ES"] = "ES";
    /**
     * France (FRA)
     */
    IsoCountryCode2Char["FR"] = "FR";
    /**
     * United Kingdom (GBR)
     */
    IsoCountryCode2Char["GB"] = "GB";
    /**
     * Ireland (IRL)
     */
    IsoCountryCode2Char["IE"] = "IE";
    /**
     * Italy (ITA)
     */
    IsoCountryCode2Char["IT"] = "IT";
    /**
     * South Korea (KOR)
     */
    IsoCountryCode2Char["KR"] = "KR";
    /**
     * Morocco (MAR)
     */
    IsoCountryCode2Char["MA"] = "MA";
    /**
     * Mauritiues (MUS)
     */
    IsoCountryCode2Char["MU"] = "MU";
    /**
     * Malaysia (MYS)
     */
    IsoCountryCode2Char["MY"] = "MY";
    /**
     * Mexico (MEX)
     */
    IsoCountryCode2Char["MX"] = "MX";
    /**
     * Netherlands (NLD)
     */
    IsoCountryCode2Char["NL"] = "NL";
    /**
     * New Zealand (NZL)
     */
    IsoCountryCode2Char["NZ"] = "NZ";
    /**
     * Oman (OMN)
     */
    IsoCountryCode2Char["OM"] = "OM";
    /**
     * Philippines (PHL)
     */
    IsoCountryCode2Char["PH"] = "PH";
    /**
     * Poland (POL)
     */
    IsoCountryCode2Char["PL"] = "PL";
    /**
     * Puerto Rico (PRI)
     */
    IsoCountryCode2Char["PR"] = "PR";
    /**
     * Portugal (PRT)
     */
    IsoCountryCode2Char["PT"] = "PT";
    /**
     * Qatar (QAT)
     */
    IsoCountryCode2Char["QA"] = "QA";
    /**
     * Romania (ROU)
     */
    IsoCountryCode2Char["RO"] = "RO";
    /**
     * Saudi Arabia (SAU)
     */
    IsoCountryCode2Char["SA"] = "SA";
    /**
     * Singapore (SGP)
     */
    IsoCountryCode2Char["SG"] = "SG";
    /**
     * Taiwan (TWN)
     */
    IsoCountryCode2Char["TW"] = "TW";
    /**
     * United States (USA)
     */
    IsoCountryCode2Char["US"] = "US";
    /**
     * South Africa (ZAF)
     */
    IsoCountryCode2Char["ZA"] = "ZA";
})(IsoCountryCode2Char = exports.IsoCountryCode2Char || (exports.IsoCountryCode2Char = {}));
var IsoCountryCodeToCurrencyNameMap;
(function (IsoCountryCodeToCurrencyNameMap) {
    /**
     * United Arab Emirates (ARE)
     */
    IsoCountryCodeToCurrencyNameMap["ARE"] = "AED";
    /**
     * Argentina (ARG)
     */
    IsoCountryCodeToCurrencyNameMap["ARG"] = "ARS";
    /**
     * Antarctica (ATA)
     */
    IsoCountryCodeToCurrencyNameMap["ATA"] = "USD";
    /**
     * Austria (AUT)
     */
    IsoCountryCodeToCurrencyNameMap["AUT"] = "EUR";
    /**
     * Australia (AUS)
     */
    IsoCountryCodeToCurrencyNameMap["AUS"] = "AUD";
    /**
     * Bahrain (BHR)
     */
    IsoCountryCodeToCurrencyNameMap["BHR"] = "BHD";
    /**
     * Brazil (BRA)
     */
    IsoCountryCodeToCurrencyNameMap["BRA"] = "BRL";
    /**
     * Canada (CAN)
     */
    IsoCountryCodeToCurrencyNameMap["CAN"] = "CAD";
    /**
     * Switzerland (CHE)
     */
    IsoCountryCodeToCurrencyNameMap["CHE"] = "CHF";
    /**
     * Chile (CHL)
     */
    IsoCountryCodeToCurrencyNameMap["CHL"] = "CLP";
    /**
     * Cayman Islands (CYM)
     */
    IsoCountryCodeToCurrencyNameMap["CYM"] = "KYD";
    /**
     * Czech Republic (CZE)
     */
    IsoCountryCodeToCurrencyNameMap["CZE"] = "CZK";
    /**
     * Germany (DEU)
     */
    IsoCountryCodeToCurrencyNameMap["DEU"] = "EUR";
    /**
     * Dominican Republic (DOM)
     */
    IsoCountryCodeToCurrencyNameMap["DOM"] = "DOP";
    /**
     * Egypt (EGY)
     */
    IsoCountryCodeToCurrencyNameMap["EGY"] = "EGP";
    /**
     * Kuwait (KWT)
     */
    IsoCountryCodeToCurrencyNameMap["KWT"] = "KWD";
    /**
     * Spain (ESP)
     */
    IsoCountryCodeToCurrencyNameMap["ESP"] = "EUR";
    /**
     * France (FRA)
     */
    IsoCountryCodeToCurrencyNameMap["FRA"] = "EUR";
    /**
     * United Kingdom (GBR)
     */
    IsoCountryCodeToCurrencyNameMap["GBR"] = "GBP";
    /**
     * Ireland (IRL)
     */
    IsoCountryCodeToCurrencyNameMap["IRL"] = "EUR";
    /**
     * Italy (ITA)
     */
    IsoCountryCodeToCurrencyNameMap["ITA"] = "EUR";
    /**
     * South Korea (KOR)
     */
    IsoCountryCodeToCurrencyNameMap["KOR"] = "KRW";
    /**
     * Morocco (MAR)
     */
    IsoCountryCodeToCurrencyNameMap["MAR"] = "MAD";
    /**
     * Mexico (MEX)
     */
    IsoCountryCodeToCurrencyNameMap["MEX"] = "MEX";
    /**
     * Mauritius (MUS)
     */
    IsoCountryCodeToCurrencyNameMap["MUS"] = "MUR";
    /**
     * Malaysia (MYS)
     */
    IsoCountryCodeToCurrencyNameMap["MYS"] = "MYR";
    /**
     * Netherlands (NLD)
     */
    IsoCountryCodeToCurrencyNameMap["NLD"] = "EUR";
    /**
     * New Zealand (NZL)
     */
    IsoCountryCodeToCurrencyNameMap["NZL"] = "NZD";
    /**
     * Oman (OMN)
     */
    IsoCountryCodeToCurrencyNameMap["OMN"] = "OMR";
    /**
     * Philippines (PHL)
     */
    IsoCountryCodeToCurrencyNameMap["PHL"] = "PHP";
    /**
     * Poland (POL)
     */
    IsoCountryCodeToCurrencyNameMap["POL"] = "PLN";
    /**
     * Portugal (PRT)
     */
    IsoCountryCodeToCurrencyNameMap["PRT"] = "EUR";
    /**
     * Puerto Rico (PRI)
     */
    IsoCountryCodeToCurrencyNameMap["PRI"] = "USD";
    /**
     * Qatar (QAT)
     */
    IsoCountryCodeToCurrencyNameMap["QAT"] = "QAR";
    /**
     * Romania (ROU)
     */
    IsoCountryCodeToCurrencyNameMap["ROU"] = "RON";
    /**
     * Saudi Arabia (SAU)
     */
    IsoCountryCodeToCurrencyNameMap["SAU"] = "SAU";
    /**
     * Singapore (SGP)
     */
    IsoCountryCodeToCurrencyNameMap["SGP"] = "SGD";
    /**
     * Taiwan (TWN)
     */
    IsoCountryCodeToCurrencyNameMap["TWN"] = "TWD";
    /**
     * United States (USA)
     */
    IsoCountryCodeToCurrencyNameMap["USA"] = "USD";
    /**
     * South Africa (ZAF)
     */
    IsoCountryCodeToCurrencyNameMap["ZAF"] = "ZAR";
})(IsoCountryCodeToCurrencyNameMap = exports.IsoCountryCodeToCurrencyNameMap || (exports.IsoCountryCodeToCurrencyNameMap = {}));
/**
 * Record mapping ISO 3166-1 alpha-2 (2 character) country code to ISO 3166-1 alpha-3 (3 character) country code
 */
exports.ISO2_ISO_MAPPING = {
    [IsoCountryCode2Char.AE]: IsoCountryCode.ARE,
    [IsoCountryCode2Char.AR]: IsoCountryCode.ARG,
    [IsoCountryCode2Char.AQ]: IsoCountryCode.ATA,
    [IsoCountryCode2Char.AT]: IsoCountryCode.AUT,
    [IsoCountryCode2Char.AU]: IsoCountryCode.AUS,
    [IsoCountryCode2Char.BH]: IsoCountryCode.BHR,
    [IsoCountryCode2Char.BR]: IsoCountryCode.BRA,
    [IsoCountryCode2Char.CA]: IsoCountryCode.CAN,
    [IsoCountryCode2Char.CH]: IsoCountryCode.CHE,
    [IsoCountryCode2Char.CL]: IsoCountryCode.CHL,
    [IsoCountryCode2Char.CZ]: IsoCountryCode.CZE,
    [IsoCountryCode2Char.DE]: IsoCountryCode.DEU,
    [IsoCountryCode2Char.DO]: IsoCountryCode.DOM,
    [IsoCountryCode2Char.ES]: IsoCountryCode.ESP,
    [IsoCountryCode2Char.EG]: IsoCountryCode.EGY,
    [IsoCountryCode2Char.FR]: IsoCountryCode.FRA,
    [IsoCountryCode2Char.GB]: IsoCountryCode.GBR,
    [IsoCountryCode2Char.IE]: IsoCountryCode.IRL,
    [IsoCountryCode2Char.IT]: IsoCountryCode.ITA,
    [IsoCountryCode2Char.KR]: IsoCountryCode.KOR,
    [IsoCountryCode2Char.KW]: IsoCountryCode.KWT,
    [IsoCountryCode2Char.KY]: IsoCountryCode.CYM,
    [IsoCountryCode2Char.MA]: IsoCountryCode.MAR,
    [IsoCountryCode2Char.MY]: IsoCountryCode.MYS,
    [IsoCountryCode2Char.MU]: IsoCountryCode.MUS,
    [IsoCountryCode2Char.MX]: IsoCountryCode.MEX,
    [IsoCountryCode2Char.NL]: IsoCountryCode.NLD,
    [IsoCountryCode2Char.NZ]: IsoCountryCode.NZL,
    [IsoCountryCode2Char.OM]: IsoCountryCode.OMN,
    [IsoCountryCode2Char.PL]: IsoCountryCode.POL,
    [IsoCountryCode2Char.PR]: IsoCountryCode.PRI,
    [IsoCountryCode2Char.PT]: IsoCountryCode.PRT,
    [IsoCountryCode2Char.PH]: IsoCountryCode.PHL,
    [IsoCountryCode2Char.QA]: IsoCountryCode.QAT,
    [IsoCountryCode2Char.RO]: IsoCountryCode.ROU,
    [IsoCountryCode2Char.SG]: IsoCountryCode.SGP,
    [IsoCountryCode2Char.SA]: IsoCountryCode.SAU,
    [IsoCountryCode2Char.TW]: IsoCountryCode.TWN,
    [IsoCountryCode2Char.US]: IsoCountryCode.USA,
    [IsoCountryCode2Char.ZA]: IsoCountryCode.ZAF,
};
exports.countryCodeToIsoCountryCodeMap = exports.ISO2_ISO_MAPPING;
/**
 * Record mapping ISO 3166-1 alpha-3 (3 character) country code to ISO 3166-1 alpha-2 (2 character) country code
 */
exports.ISO_ISO2_MAPPING = {
    [IsoCountryCode.ARE]: IsoCountryCode2Char.AE,
    [IsoCountryCode.ARG]: IsoCountryCode2Char.AR,
    [IsoCountryCode.ATA]: IsoCountryCode2Char.AQ,
    [IsoCountryCode.AUT]: IsoCountryCode2Char.AT,
    [IsoCountryCode.AUS]: IsoCountryCode2Char.AU,
    [IsoCountryCode.BHR]: IsoCountryCode2Char.BH,
    [IsoCountryCode.BRA]: IsoCountryCode2Char.BR,
    [IsoCountryCode.CAN]: IsoCountryCode2Char.CA,
    [IsoCountryCode.CHE]: IsoCountryCode2Char.CH,
    [IsoCountryCode.CHL]: IsoCountryCode2Char.CL,
    [IsoCountryCode.CYM]: IsoCountryCode2Char.KY,
    [IsoCountryCode.CZE]: IsoCountryCode2Char.CZ,
    [IsoCountryCode.DEU]: IsoCountryCode2Char.DE,
    [IsoCountryCode.DOM]: IsoCountryCode2Char.DO,
    [IsoCountryCode.ESP]: IsoCountryCode2Char.ES,
    [IsoCountryCode.EGY]: IsoCountryCode2Char.EG,
    [IsoCountryCode.FRA]: IsoCountryCode2Char.FR,
    [IsoCountryCode.GBR]: IsoCountryCode2Char.GB,
    [IsoCountryCode.IRL]: IsoCountryCode2Char.IE,
    [IsoCountryCode.ITA]: IsoCountryCode2Char.IT,
    [IsoCountryCode.KOR]: IsoCountryCode2Char.KR,
    [IsoCountryCode.KWT]: IsoCountryCode2Char.KW,
    [IsoCountryCode.MAR]: IsoCountryCode2Char.MA,
    [IsoCountryCode.MEX]: IsoCountryCode2Char.MX,
    [IsoCountryCode.MUS]: IsoCountryCode2Char.MU,
    [IsoCountryCode.MYS]: IsoCountryCode2Char.MY,
    [IsoCountryCode.NLD]: IsoCountryCode2Char.NL,
    [IsoCountryCode.NZL]: IsoCountryCode2Char.NZ,
    [IsoCountryCode.OMN]: IsoCountryCode2Char.OM,
    [IsoCountryCode.POL]: IsoCountryCode2Char.PL,
    [IsoCountryCode.PRI]: IsoCountryCode2Char.PR,
    [IsoCountryCode.PRT]: IsoCountryCode2Char.PT,
    [IsoCountryCode.PHL]: IsoCountryCode2Char.PH,
    [IsoCountryCode.QAT]: IsoCountryCode2Char.QA,
    [IsoCountryCode.ROU]: IsoCountryCode2Char.RO,
    [IsoCountryCode.SGP]: IsoCountryCode2Char.SG,
    [IsoCountryCode.SAU]: IsoCountryCode2Char.SA,
    [IsoCountryCode.TWN]: IsoCountryCode2Char.TW,
    [IsoCountryCode.USA]: IsoCountryCode2Char.US,
    [IsoCountryCode.ZAF]: IsoCountryCode2Char.ZA,
};
/**
 * Maps an upper case country name to the ISO 3166-1 alpha-2 (2 character) country code
 */
exports.UPPER_CASE_COUNTRY_NAME_TO_ISO2_MAPPING_GENERATED = {
    ['ANTARCTICA']: IsoCountryCode2Char.AQ,
    ['ARGENTINA']: IsoCountryCode2Char.AR,
    ['AUSTRALIA']: IsoCountryCode2Char.AU,
    ['AUSTRIA']: IsoCountryCode2Char.AT,
    ['BAHRAIN']: IsoCountryCode2Char.BH,
    ['BRAZIL']: IsoCountryCode2Char.BR,
    ['CANADA']: IsoCountryCode2Char.CA,
    ['CAYMAN ISLANDS']: IsoCountryCode2Char.KY,
    ['CHILE']: IsoCountryCode2Char.CL,
    ['CZECH REPUBLIC']: IsoCountryCode2Char.CZ,
    ['DOMINICAN REPUBLIC']: IsoCountryCode2Char.DO,
    ['EGYPT']: IsoCountryCode2Char.EG,
    ['FRANCE']: IsoCountryCode2Char.FR,
    ['GERMANY']: IsoCountryCode2Char.DE,
    ['IRELAND']: IsoCountryCode2Char.IE,
    ['ITALY']: IsoCountryCode2Char.IT,
    ['KUWAIT']: IsoCountryCode2Char.KW,
    ['MALAYSIA']: IsoCountryCode2Char.MY,
    ['MAURITIUS']: IsoCountryCode2Char.MY,
    ['MEXICO']: IsoCountryCode2Char.MX,
    ['MOROCCO']: IsoCountryCode2Char.MA,
    ['NETHERLANDS']: IsoCountryCode2Char.NL,
    ['NEW ZEALAND']: IsoCountryCode2Char.NZ,
    ['OMAN']: IsoCountryCode2Char.OM,
    ['PHILIPPINES']: IsoCountryCode2Char.PH,
    ['POLAND']: IsoCountryCode2Char.PL,
    ['PORTUGAL']: IsoCountryCode2Char.PT,
    ['PUERTO RICO']: IsoCountryCode2Char.PR,
    ['QATAR']: IsoCountryCode2Char.QA,
    ['ROMANIA']: IsoCountryCode2Char.RO,
    ['SAUDI ARABIA']: IsoCountryCode2Char.SA,
    ['SINGAPORE']: IsoCountryCode2Char.SG,
    ['SOUTH AFRICA']: IsoCountryCode2Char.ZA,
    ['SOUTH KOREA']: IsoCountryCode2Char.KR,
    ['SPAIN']: IsoCountryCode2Char.ES,
    ['SWITZERLAND']: IsoCountryCode2Char.CH,
    ['TAIWAN']: IsoCountryCode2Char.TW,
    ['UNITED ARAB EMIRATES']: IsoCountryCode2Char.AE,
    ['UNITED KINGDOM']: IsoCountryCode2Char.GB,
    ['UNITED STATES']: IsoCountryCode2Char.US,
};
//# sourceMappingURL=generated.js.map